import { lazy } from 'react';
import { DCR_DASHBOARD_PERMISSIONS, DCR_DASHBOARD_ROLES } from 'common/utils/dcrConstants';

export let routes = [
    {
        component: lazy(() => import('module/dcrDashboard/DcrDashboardPage')),
        permissions: DCR_DASHBOARD_PERMISSIONS,
        role: DCR_DASHBOARD_ROLES,
        path: '/dcrDashboard',
    },
];
